// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13tAP","title":"styles_title__2aBIj"};